<template>
  <div class="ma-4 app">
    <div class="text-h4 mb-2">Cadastro de Tronco</div>
    <v-tabs v-model="tabs" background-color="background">
      <v-tab v-for="n in tipos" :key="n">
        {{ tipo[n - 1] }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <AbaTroncoPjsip edicao="false" />
      </v-tab-item>
      <v-tab-item>
        <AbaTroncoPjsipTrunk edicao="false" />
      </v-tab-item>
      <v-tab-item>
        <AbaTroncoIax edicao="false" />
      </v-tab-item>
      <v-tab-item>
        <AbaTroncoIaxTrunk edicao="false" />
      </v-tab-item>
      <v-tab-item>
        <AbaTroncoKhomp edicao="false" />
      </v-tab-item>
      <v-tab-item>
        <AbaTroncoSipProxy edicao="false" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AbaTroncoPjsip from '../_components/AbaTroncoPjsip'
import AbaTroncoPjsipTrunk from '../_components/AbaTroncoPjsipTrunk'
import AbaTroncoIax from '../_components/AbaTroncoIax'
import AbaTroncoIaxTrunk from '../_components/AbaTroncoIaxTrunk'
import AbaTroncoKhomp from '../_components/AbaTroncoKhomp'
import AbaTroncoSipProxy from '../_components/AbaTroncoSipProxy'

export default {
  name: 'CadastroTroncos',
  components: { AbaTroncoPjsip, AbaTroncoPjsipTrunk, AbaTroncoIax, AbaTroncoIaxTrunk, AbaTroncoKhomp, AbaTroncoSipProxy },
  data: () => ({
    tipos: 6,
    tab: null,
    tabs: 6,
    tipo: ['PJSIP', 'PJSIPTRUNK', 'IAX', 'IAXTRUNK', 'KHOMP', 'SIP-PROXY'],
  }),
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
